function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Brand=
function Brand(id,name,isActive){_classCallCheck(this,Brand);
this.id=id;
this.name=name;
this.isActive=isActive;
};


export default Brand;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9tb2RlbHMvQnJhbmQuanMiXSwibmFtZXMiOlsiQnJhbmQiLCJpZCIsIm5hbWUiLCJpc0FjdGl2ZSJdLCJtYXBwaW5ncyI6Im9KQUFNQSxNO0FBQ0osZUFBWUMsRUFBWixDQUFnQkMsSUFBaEIsQ0FBc0JDLFFBQXRCLENBQWdDO0FBQzlCLEtBQUtGLEVBQUwsQ0FBVUEsRUFBVjtBQUNBLEtBQUtDLElBQUwsQ0FBWUEsSUFBWjtBQUNBLEtBQUtDLFFBQUwsQ0FBZ0JBLFFBQWhCO0FBQ0QsQzs7O0FBR0gsY0FBZUgsTUFBZiIsImZpbGUiOiJCcmFuZC5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiY2xhc3MgQnJhbmQge1xuICBjb25zdHJ1Y3RvcihpZCwgbmFtZSwgaXNBY3RpdmUpIHtcbiAgICB0aGlzLmlkID0gaWQ7XG4gICAgdGhpcy5uYW1lID0gbmFtZTtcbiAgICB0aGlzLmlzQWN0aXZlID0gaXNBY3RpdmU7XG4gIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgQnJhbmQ7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/models/Brand.js
// module id = 305
// module chunks = 0